export type AggregationType = 'sum' | 'avg' | 'count' | 'min' | 'max';

export type AggregationConfig = Record<string, AggregationType>;

export interface AggregationResult {
  field: string;
  type: AggregationType;
  value: number;
}

export function sum(values: number[]): number {
  return values.reduce((acc, val) => acc + (val || 0), 0);
}

export function avg(values: number[]): number {
  if (values.length === 0) return 0;
  return sum(values) / values.length;
}

export function count(values: unknown[]): number {
  return values.length;
}

export function min(values: number[]): number {
  if (values.length === 0) return 0;
  return Math.min(...values.filter(v => v !== null && v !== undefined));
}

export function max(values: number[]): number {
  if (values.length === 0) return 0;
  return Math.max(...values.filter(v => v !== null && v !== undefined));
}

export function aggregate(values: unknown[], type: AggregationType): number {
  const numericValues = values.filter(v => typeof v === 'number') as number[];

  switch (type) {
    case 'sum':
      return sum(numericValues);
    case 'avg':
      return avg(numericValues);
    case 'count':
      return count(values);
    case 'min':
      return min(numericValues);
    case 'max':
      return max(numericValues);
    default:
      return 0;
  }
}

export function formatAggregation(value: number, type: AggregationType): string {
  switch (type) {
    case 'count':
      return value.toString();
    case 'avg':
      return value.toFixed(2);
    default:
      return value.toLocaleString();
  }
}
